import { Injectable, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';

import { BcmUserSettingsFacade } from '@bcmServices/settings/bcm-user-settings-facade';
import { BcmUserSettingKey } from '@shared/models/bcm-settings-user';

// Exposes the current user's beta features flags as signals (per-user, self-service).
@Injectable({ providedIn: 'root' })
export class BetaFeaturesService {

    private readonly userSettingsFacade = inject(BcmUserSettingsFacade);

    private readonly section = toSignal(
        this.userSettingsFacade.settings$.pipe(
            map((settings) => settings?.[BcmUserSettingKey.BetaFeatures]),
        ),
        { initialValue: undefined },
    );

    readonly bookingDialogV2 = computed(() => !!this.section()?.bookingDialogV2);
    readonly pricingV2 = computed(() => !!this.section()?.pricingV2);
}
